import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GlobalVars } from '../../providers/global-vars';
import { ApiCaller } from '../../providers/api-caller';
import { trigger, state, style, transition, animate, keyframes } from '@angular/core';
import {TranslateService} from 'ng2-translate/ng2-translate';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import { GateGuestsPage } from '../../pages/gate-guests/gate-guests';





/*
  Generated class for the MyGates page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-my-gates',
  templateUrl: 'my-gates.html',
  animations: [

    trigger('flip', [
      state('flipped', style({
        transform: 'scale(2)',
    //        transform: 'rotate(180deg)',
      })),
      transition('* => flipped', animate('400ms ease')),
      transition('flipped => *', animate('400ms ease'))
    ]),

    trigger('SlideIn', [
      state('in', style({transform: 'translateX(0)'})),
      state('inRight', style({transform: 'translateX(0)'})),
      state('outLeft', style({transform: 'translateX(-150%)'})),
      state('outRight', style({transform: 'translateX(150%)'})),
      transition('* => in', [
        animate(1000, keyframes([
          style({opacity: 0, transform: 'translateX(-100%)', offset: 0}),
          style({opacity: 0.2, transform: 'translateX(15px)',  offset: 0.3}),
          style({opacity: 1, transform: 'translateX(0)',     offset: 1.0})
        ]))
      ]),
      transition('outLeft => in', [
        animate(1000, keyframes([
          style({opacity: 0, transform: 'translateX(-100%)', offset: 0}),
          style({opacity: 0.2, transform: 'translateX(15px)',  offset: 0.3}),
          style({opacity: 1, transform: 'translateX(0)',     offset: 1.0})
        ]))
      ]),
      transition('* => inRight', [
        animate(1000, keyframes([
          style({opacity: 0, transform: 'translateX(100%)', offset: 0}),
          style({opacity: 0.2, transform: 'translateX(15px)',  offset: 0.3}),
          style({opacity: 1, transform: 'translateX(0)',     offset: 1.0})
        ]))
      ]),
      transition('in => outLeft', [
        animate(300, keyframes([
          style({transform: 'translateX(0)', offset: 0}),
          style({transform: 'translateX(15px)',  offset: 0.3}),
          style({transform: 'translateX(-150%)',     offset: 1.0})
        ]))
      ]),
      transition('in => outRight', [
        animate(300, keyframes([
          style({transform: 'translateX(0)', offset: 0}),
          style({transform: 'translateX(15px)',  offset: 0.3}),
          style({transform: 'translateX(150%)',     offset: 1.0})
        ]))
      ])

    ])
  ]
})
export class MyGatesPage {
    
    public login: any = {};
    public invalidCounter: any = 0;
    public waitingTime: any = 0;
    public timedOut:any = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public apiCaller : ApiCaller, 
              public globalVars : GlobalVars, private translate: TranslateService,
             private idle: Idle, private keepalive: Keepalive) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad MyGatesPage '+JSON.stringify(this.globalVars.userSettings));
       this.globalVars.loadSettings(false).then((success) =>{
                   console.log('After loadSettings MyGatesPage '+JSON.stringify(this.globalVars.userSettings));
       });
  }
 
    startTimer(){
        this.idle.setIdle(1);
        this.idle.setTimeout(8*this.invalidCounter);
  //      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onTimeoutWarning.subscribe((countdown:number) => {
          console.log('TimeoutWarning: ' + countdown);
            this.waitingTime = countdown;
        });

        this.idle.onTimeout.subscribe(() => {
          console.log('Timeout');
            this.timedOut = true;
          this.doLogout();
        });
        this.idle.watch();
    }

    doLogin(){
        if (!this.login.code || this.login.code.length <= 0){
            this.globalVars.showAlert('Missing info','Please enter your login code');
            return;
        }

        console.log("Processing login code: "+this.login.code);
        var requestApp = {};
        (requestApp as any).requestType = 'validateWebLogin';
      
        (requestApp as any).request = {};
        (requestApp as any).request.code = this.login.code;
        
        this.apiCaller.load(requestApp, this.globalVars.msgPleaseWait, this.invalidCounter < 2).then(data => {
            if (data && (data as any).result == 200){
                this.globalVars.userSettings = (data as any).data;
                this.globalVars.devices = (data as any).devices;
                this.globalVars.generalVars.activationCode = (data as any).activationCode;
                this.globalVars.saveSettings();
           //     this.startTimer();
            }else{
                this.invalidCounter++;
                if (this.invalidCounter > 2){
                    this.globalVars.showAlert('Problem?','Try getting a new code on the app and try again.');
                    this.waitingTime = 8*this.invalidCounter;
                    this.startTimer();
                }
            }
        });
    }
    
    eventHandler(keyCode) {
        if (keyCode == 13)
            this.doLogin();
    }
    deviceGuests(whichOne){
        this.navCtrl.push(GateGuestsPage,{theDevice:whichOne });
    }
    doLogout(){
    //    this.login.code = '';
        this.globalVars.userSettings = null;
        this.globalVars.devices = null;
        this.idle.stop();
        this.waitingTime = 0;
        this.globalVars.clearSettings();
        /*
        this._headerService.exit()
            .subscribe(
                data => {
                    
                },
                    error => console.log(error)
            ) 
            */
    }

    useDevice(whichOne, askOwner, reason){
        
        whichOne.flip_open = 'flipped';
         setTimeout(() => {
             whichOne.flip_open = '';
        }, 2000);
        var requestApp = {};
        (requestApp as any).requestType = 'useDevice';
      
        (requestApp as any).request = {};
        (requestApp as any).request.userId = this.globalVars.userSettings.user_id;
        (requestApp as any).request.activationCode = this.globalVars.generalVars.activationCode;
        (requestApp as any).request.deviceUserId = whichOne.device_user_id;
        if (askOwner){
            (requestApp as any).request.askOwner = askOwner;
            (requestApp as any).request.reason = reason;
        }
        
        this.apiCaller.load(requestApp, this.globalVars.msgPleaseWait, true).then(data => {
            if (data && (data as any).result == 200){
                
                console.log('Got back: '+JSON.stringify(data));
              //  if ((data as any).need_realtime_approval)
                whichOne.need_realtime_approval = (data as any).need_realtime_approval;
 
                
                
 
 
                if (whichOne.need_realtime_approval){
                    this.translate.get('Asking to open', {granted_by_name:whichOne.granted_by_name, gate_name:whichOne.name}).subscribe(localizedValue =>{
                        
                        this.globalVars.showToast(localizedValue,"long", "center");
                    });
                }
                    
                else{
                    this.translate.get('Opening gate', {gate_name:whichOne.name}).subscribe(localizedValue =>{
                        
                        this.globalVars.showToast(localizedValue,"long", "center");
                        
                    });
                }
                
            }else{
                if (data && (data as any).result == 555){
                    // Not allowed
                    whichOne.can_use_now = 0;
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/my-gates/my-gates.ts